// athletes.height_in stays total inches in the database (unchanged) — these
// helpers exist purely so the UI can show/collect feet & inches, which is
// how people actually think about height, without touching storage.

export function formatHeight(totalInches) {
  if (totalInches === null || totalInches === undefined || Number.isNaN(totalInches)) return null;
  const feet = Math.floor(totalInches / 12);
  const inches = Math.round(totalInches % 12);
  return `${feet}'${inches}"`;
}

/** Options for a height <select>, e.g. [{ value: 58, label: "4'10\"" }, ...].
 * Default range 3'0" (36") to 7'0" (84") covers youth through adult sizes. */
export function buildHeightOptions(minInches = 36, maxInches = 84) {
  const options = [];
  for (let inches = minInches; inches <= maxInches; inches++) {
    options.push({ value: inches, label: formatHeight(inches) });
  }
  return options;
}
